import React from 'react';
export function Contact() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-625">
      <h1 className="text-4xl font-bold text-white mb-4 font-title" data-id="element-626">
        Contact Us
      </h1>
      <p className="text-neutral-400 mb-12 font-body text-lg" data-id="element-627">
        Have questions about GigaBrain? We'd love to hear from you.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-628">
        <div data-id="element-629">
          <div className="space-y-8" data-id="element-630">
            <div data-id="element-631">
              <h3 className="text-sm font-semibold text-neutral-500 uppercase tracking-wider mb-2" data-id="element-632">
                Email
              </h3>
              <a href="mailto:hello@gigabrain.dev" className="text-white hover:text-blue-400 transition-colors text-lg" data-id="element-633">
                hello@gigabrain.dev
              </a>
            </div>

            <div data-id="element-634">
              <h3 className="text-sm font-semibold text-neutral-500 uppercase tracking-wider mb-2" data-id="element-635">
                Social
              </h3>
              <a href="https://twitter.com/gigabrain" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-400 transition-colors text-lg" data-id="element-636">
                @gigabrain on X
              </a>
            </div>
          </div>
        </div>

        <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-6" data-id="element-637">
          <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-638">
            <div data-id="element-639">
              <label htmlFor="email" className="block text-sm font-medium text-neutral-400 mb-1.5" data-id="element-640">
                Email Address
              </label>
              <input type="email" id="email" className="w-full bg-neutral-950 border border-neutral-800 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all" placeholder="you@company.com" data-id="element-641" />
            </div>

            <div data-id="element-642">
              <label htmlFor="message" className="block text-sm font-medium text-neutral-400 mb-1.5" data-id="element-643">
                Message
              </label>
              <textarea id="message" rows={4} className="w-full bg-neutral-950 border border-neutral-800 rounded-lg px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-500 transition-all resize-none" placeholder="How can we help?" data-id="element-644" />
            </div>

            <button type="submit" className="w-full bg-white text-black font-medium rounded-lg px-4 py-2.5 hover:bg-neutral-200 transition-colors mt-2" data-id="element-645">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>;
}